import React, {memo, useState} from 'react'
import {connect} from 'react-redux'
import s from './index.module.less'
import { getUserInfo } from "@/api/index";

const ThankModal = (props) => {
  const {updateThankModalVisible, updateUserInfo} = props
  const [isClosing, setIsClosing] = useState(false);

  // 更新算力
  const updateTops = () => {
    getUserInfo({
      invite_code: localStorage.getItem('userInviteCode')
    }).then(res => {
      if (res.status === 200) {
        const user_info = res.data;
        localStorage.setItem("userInfo", JSON.stringify(user_info));
        updateUserInfo(user_info);
      }
    });
  }

  const closeModal = () => {
    updateTops(); // 关闭弹窗时更新算力
    setIsClosing(true);
    const timer = setTimeout(() => {
      updateThankModalVisible(false)
      clearTimeout(timer)
    }, 300); // 动画执行完后再隐藏
  }

  return (
    <div className={s.thankModalWrap}>
      <div className={`${s.thankModalInner} ${isClosing ? s.closing : ''}`}>
        <div className={s.thankModalClose} onClick={() => closeModal()}>
          <i className='iconfont icon-rongqi1' style={{fontSize: '32px'}}></i>
        </div>
        <div className={s.thankModalContent}>
          <div className={s.thankModalCard}>
            <div className={s.thankModalTxt1}>感谢使用溜溜AI</div>
            <div className={s.thankModalTxt2}>免费赠送算力</div>
            <div className={s.thankModalTxt1}>助你设计效率加倍</div>
          </div>
          <div className={s.thankModalButton} onClick={() => closeModal()} style={{marginTop: '26px'}}>
            <span className={s.thankModalButtonTxt}>点击领取30</span>
            <div className={s.thankModalButtonImg}></div>
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = ({app}) => {
  return {
    userInfo: app.userInfo,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateThankModalVisible: (params) => {
      return dispatch({
        type: 'app/updateThankModalVisible',
        payload: params,
      })
    },
    updateUserInfo: (params) => {
      return dispatch({
        type: "app/setUserInfo",
        payload: params
      });
    },
  }
}

export default memo(connect(mapStateToProps, mapDispatchToProps)(ThankModal))
